import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../../../../store/store';
import { unwrapUserProfile } from '../../application/mapUserProfile';
import type { UserProfile } from '../../application/types';

const API_HOST = process.env.REACT_APP_API_HOST || '/v1/';
const API_BASE_URL = API_HOST.endsWith('/') ? API_HOST : `${API_HOST}/`;

export const userProfileApi = createApi({
  reducerPath: 'userProfileApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth?.accessToken;
      if (token) {
        headers.set(
          'Authorization',
          token.startsWith('Bearer ') ? token : `Bearer ${token}`,
        );
      }
      return headers;
    },
  }),
  tagTypes: ['UserProfile'],
  endpoints: build => ({
    getProfile: build.query<UserProfile, void>({
      query: () => ({
        url: 'users/profile',
        method: 'GET',
      }),
      transformResponse: unwrapUserProfile,
      providesTags: ['UserProfile'],
    }),
  }),
});

export const { useGetProfileQuery } = userProfileApi;
